module.exports = __webpack_public_path__ + "static/img/bg-noppakao-lanscape.cd4a773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-noppakao-lanscape.png
// module id = aQwF
// module chunks = 3